
Librarian.Zoom = new Class({
    Implements: Options,
    Binds: ["load", "reset", "doZoom", "onMouseWheel",
            "checkPositionLimits", "setImagePosition", "destroy"],

    options: {
        image: null,
        window: null,
        contentWrapper: null,
        imageContainer: null,
        zoomFactor: 0.25,
        maxZoom: 3.0,
        reverseWidthCheck: false,
        defaultZoomLevel: 1.0
    },

    zoomLevel: 1.0,
    originalSize: {},
    originalScroll: {},
    drag: null,
    justDragged: false,

    initialize: function(options) {
        this.setOptions(options);

        // If we're given an ID, try to get the element
        if (typeof this.options.image == "string")
            this.options.image = $(this.options.image);

        // If the element is null, don't continue
        if (this.options.image == null)
            return;

        this.load();
    },

    destroy: function() {
        if (this.options.image)
            this.options.image = null;

        if (this.options.window)
            this.options.window = null;

        if (this.options.contentWrapper)
            this.options.contentWrapper = null;

        if (this.options.imageContainer)
            this.options.imageContainer = null;

        if (this.drag) {
            // Work around for IE 8 forgetting these things are mootools objects
            // This used to call this.drag.detach();
            $(this.drag.handles).removeEvents();
            this.drag.removeEvents();

            this.drag.cancel();
            this.drag = null;
        }
    },

    reset: function(data) {
        // If the element is null, don't continue
        if (this.options.image == null)
            return;

        // If we're not given data, start with an empty object
        if ((typeof data == "undefined") || (data == null))
            data = {};
        // If we're not given a width, get the image's width
        if (data.width == null)
            data.width = this.options.image.getWidth();
        // If we're not given a height, get the image's height
        if (data.height == null)
            data.height = this.options.image.getHeight();
        // If we're not given a constraint setting, use the default
        if (data.reverseWidthCheck == null)
            data.reverseWidthCheck = false;

        // Save the height and width
        this.originalSize.y = data.height;
        this.originalSize.x = data.width;
        // Save the scroll position
        this.originalScroll.x = null;
        this.originalScroll.y = null;
        // Reset the position to the top left corner
        this.setImagePosition(0, 0);
        // Remove the zoomed class
        this.options.image.removeClass("zoomed");
        // Set the constraint setting to the given value
        this.options.reverseWidthCheck = data.reverseWidthCheck;
        // Reset the zoom level to the default
        this.zoomLevel = this.options.defaultZoomLevel;
        // Reset the drag state
        this.justDragged = false;
        // If we were given a content wrapper, reset the overflow to auto
        if (this.options.contentWrapper)
            this.options.contentWrapper.setStyle("overflow", "auto");
    },

    load: function() {
        // If the element is null, don't continue
        if (this.options.image == null)
            return;

        // Reset this to the defaults
        this.reset();

        // Reset the drag handler, if there is one
        if (this.drag) {
            this.drag.detach();
            this.drag.cancel();
            this.drag = null;
        }

        // Remove all mousehweel events
        this.options.image.removeEvents("mousewheel");

        // Create the new drag handler for the image
        this.drag = new Drag(this.options.image.id, {
            onComplete: function() {
                this.justDragged = true;
            }.bind(this)
        });
        // Start with it detached
        this.drag.detach();

        // Add the mousewheel handler
        this.options.image.addEvent("mousewheel", this.onMouseWheel);

        // Zoom in if the default level isn't no soom
        if (this.zoomLevel != 1.0)
            this.doZoom();
    },

    onMouseWheel: function(e) {
        // If the element is null, don't continue
        if (this.options.image == null)
            return;

        // Get the correct event
        var evt = new Event(e);
        // Iterate the zoom level by the zoom factor in the direction the mouse wheel is turning
        var zoomAmount = this.zoomLevel + (this.options.zoomFactor * evt.wheel);
        var naturalZoom = this.getNaturalDimensionsZoomLevel();
        var lowerTolerance = 1.0 - this.options.zoomFactor;
        var upperTolerance = 1.0 + this.options.zoomFactor;

        if (zoomAmount !== naturalZoom && zoomAmount > lowerTolerance && zoomAmount < upperTolerance) {
            this.zoomLevel = 1;
        } else {
            this.zoomLevel += (this.options.zoomFactor * evt.wheel);
        }

        // Do the zoom
        this.doZoom(evt.page, evt.wheel);

        evt = null;
    },

    doZoom: function(mousePos, direction) {
        // Detach the drag handler
        if (this.drag)
            this.drag.detach();

        var natZoomLevel = this.getNaturalDimensionsZoomLevel();
        var minZoomLevel = Math.min(natZoomLevel, 1);
        if (this.zoomLevel < minZoomLevel) {
            this.zoomLevel = minZoomLevel;
        }

        // If we're less than 1.0 zoom
        if (this.zoomLevel == 1.0) {
            // Reset to 1.0
            this.zoomLevel = 1.0;
            // Remove the "zoomed" class
            this.options.image.removeClass("zoomed");
            // And reset the position
            this.setImagePosition(0, 0);
            // Reset scroll positions, if we haven't already
            if (this.originalScroll.x != null) {
                if (this.options.imageContainer)
                    this.options.imageContainer.scrollLeft = this.originalScroll.x;
                else if (this.options.contentWrapper)
                    this.options.contentWrapper.scrollLeft = this.originalScroll.x;

                this.originalScroll.x = null;
            }
            if (this.originalScroll.y != null) {
                if (this.options.imageContainer)
                    this.options.imageContainer.scrollTop = this.originalScroll.y;
                else if (this.options.contentWrapper)
                    this.options.contentWrapper.scrollTop = this.originalScroll.y;

                this.originalScroll.y = null;
            }
            // Reset the height
            this.options.image.style.height = '';
            // Set the width of the image to the zoomed width
            this.options.image.style.width = (this.originalSize.x * this.zoomLevel) + "px";

            // If we were given a content wrapper, reset the overflow to auto
            if (this.options.contentWrapper)
                this.options.contentWrapper.setStyle("overflow", "auto");
        }
        else {
            // If the zoom is past the maximum level, reset it to the maximum
            if (this.zoomLevel > this.options.maxZoom) {
                this.zoomLevel = this.options.maxZoom;
                // Reset the height
                this.options.image.style.height = '';
                // Set the width of the image to the zoomed width
                this.options.image.style.width = (this.originalSize.x * this.zoomLevel) + "px";
            }
            // Otherwise, handle zooming to the current mouse position
            else {
                // Calculate the new width and height
                var newWidth = (this.originalSize.x * this.zoomLevel);
                var newHeight = (this.originalSize.y * this.zoomLevel);

                // Reset the height
                this.options.image.style.height = '';
                // Set the width of the image to the zoomed width
                this.options.image.style.width = newWidth + "px";

                // Center image if zoomLevel is below 1
                if (this.zoomLevel <= 1.0) {
                    if (this.options.contentWrapper) {
                        var height = this.options.contentWrapper.getHeight();
                        var width = this.options.contentWrapper.getWidth();

                        var imgHeight = this.options.image.getHeight();
                        var imgWidth = this.options.image.getWidth();

                        this.setImagePosition((width - imgWidth) / 2.0, (height -imgHeight) / 2.0);
                    }
                }
                // If no position is specified, center the image horizontally and scroll to top
                else if (mousePos == null) {
                    if (this.options.contentWrapper) {
                        var width = this.options.contentWrapper.getWidth();
                        var imgWidth = this.options.image.getWidth();

                        this.setImagePosition((width - imgWidth) / 2.0, 0);
                    }
                } else {
                    var imageCoords = this.options.image.getCoordinates();

                    // Get the percent of the width of the image that the mouse is from the left
                    var percentX = (mousePos.x - imageCoords.left) / imageCoords.width;
                    // Get the percent of the height of the image that the mouse is from the top
                    var percentY = (mousePos.y - imageCoords.top) / imageCoords.height;

                    var scrollLeft = 0;
                    var scrollTop = 0;

                    // Get the scroll positions if we have a wrapper
                    if (this.options.imageContainer) {
                        scrollLeft = this.options.imageContainer.scrollLeft;
                        scrollTop = this.options.imageContainer.scrollTop;
                    } else if (this.options.contentWrapper) {
                        scrollLeft = this.options.contentWrapper.scrollLeft;
                        scrollTop = this.options.contentWrapper.scrollTop;
                    }

                    // Calculate the new left position from the current left, width, x%, image offset, and the scroll position.
                    var newLeft = ((imageCoords.left - ((newWidth - imageCoords.width) * percentX)) - imageCoords.left + this.options.image.style.left.toInt()) - scrollLeft;

                    // Ignore the initial image offset when first zooming in on a maximized image
                    if (this.options.reverseWidthCheck && (direction == 1) &&
                    ((this.zoomLevel - this.options.zoomFactor) == this.options.defaultZoomLevel))
                        newLeft += imageCoords.left;

                    // Calculate the new top position from the current top, height, y%, image offset, and the scroll position.
                    var newTop = ((imageCoords.top - ((newHeight - imageCoords.height) * percentY)) - imageCoords.top + this.options.image.style.top.toInt()) - scrollTop;

                    // Calculate the new position limits from the size of the image
                    this.calculatePositionLimits();

                    // Get the left/top values within the limited space
                    var safeValues = this.getLimitedPosition(newLeft, newTop);

                    // And then set the image's position to the new ones
                    this.setImagePosition(safeValues.left, safeValues.top);
                }
           
                // Save and reset the scroll positions
                if (this.originalScroll.x == null) {
                    this.originalScroll.x = scrollLeft;

                    if (this.options.imageContainer)
                        this.options.imageContainer.scrollLeft = 0;
                    else if (this.options.contentWrapper)
                        this.options.contentWrapper.scrollLeft = 0;
                }
                if (this.originalScroll.y == null) {
                    this.originalScroll.y = scrollTop;

                    if (this.options.imageContainer)
                        this.options.imageContainer.scrollTop = 0;
                    else if (this.options.contentWrapper)
                        this.options.contentWrapper.scrollTop = 0;
                }
            }

            // Add the "zoomed" class
            if (!this.options.image.hasClass("zoomed"))
                this.options.image.addClass("zoomed");

            if (this.zoomLevel > 1.0) {
                // If we were given a content wrapper, set the overflow to hidden so no scrollbars show
                if (this.options.contentWrapper)
                    this.options.contentWrapper.setStyle("overflow", "hidden");

                // And re-attach the drag handler, if we have one
                if (this.drag)
                    this.drag.attach();
            }
        }
    },

    calculatePositionLimits: function() {
        // Don't bother if we don't have a drag handler
        if (!this.drag)
            return;

        // Get the image's width and height
        var width = this.options.image.getWidth();
        var height = this.options.image.getHeight();
        // Calculate the limits from the original sizes
        var heightLimit = height;
        var widthLimit = width;

        // If there is a content wrapper, use its dimensions, otherwise use the image dimensions
        if (this.options.imageContainer)
            widthLimit -= this.options.imageContainer.getWidth();
        else if (this.options.contentWrapper)
            widthLimit -= this.options.contentWrapper.getWidth();
        else
            widthLimit -= this.originalSize.x;

        if (this.options.contentWrapper)
            heightLimit -= this.options.contentWrapper.getHeight();
        else
            heightLimit -= this.originalSize.y;

        // Create the limit object with the correct bounds for the correct width check type
        // Only use the reverse width check if the image has a smaller width than the parent window
        if (this.options.reverseWidthCheck && (!this.options.window || (this.options.window.getWidth() > width)))
            this.drag.options.limit = { x: [0, (-1.0 * widthLimit)], y: [(-1.0 * heightLimit), 0] };
        else
            this.drag.options.limit = { x: [(-1.0 * widthLimit), 0], y: [(-1.0 * heightLimit), 0] };
    },

    zoomTo: function(left, top, zoom) {
        // If the element is null, don't continue
        if (this.options.image == null)
            return;

        // If the zoom level is a number
        if (!isNaN(zoom)) {
            // And it is within the [1.0, max] limits
            if (zoom > 1.0)
                zoom = 1.0;
            if (zoom < this.options.maxZoom)
                zoom = this.options.maxZoom;

            // Save it
            this.zoomLevel = zoom;
        }

        // Always do the zoom so we know that
        // the position limits have been calculated
        this.doZoom();

        // Get the currnet image position
        var imagePos = this.options.image.getPosition(this.options.image.parentElement);
        // Whether or not the position has changed
        var modified = false;

        // If left isn't valid, save the image's current left
        if (isNaN(left))
            left = imagePos.x;
        // Otherwise mark it as modified
        else
            modified = true;

        // If top isn't valid, save the image's current top
        if (isNaN(top))
            top = imagePos.x;
        // Otherwise mark it as modified
        else
            modified = true;

        // If the positions have been modified
        if (modified) {
            var safeValues = this.getLimitedPosition(left, top);

            // And then set the image's position to the new ones
            this.setImagePosition(safeValues.left, safeValues.top);
        }
    },

    getLimitedPosition: function(left, top) {
        var newLeft = left, newTop = top;

        // Make sure the left position is within the calculated limits
        if (newLeft < this.drag.options.limit.x[0])
            newLeft = this.drag.options.limit.x[0];
        if (newLeft > this.drag.options.limit.x[1])
            newLeft = this.drag.options.limit.x[1];

        // Make sure the top position is within the calculated limits
        if (newTop < this.drag.options.limit.y[0])
            newTop = this.drag.options.limit.y[0];
        if (newTop > this.drag.options.limit.y[1])
            newTop = this.drag.options.limit.y[1];

        return { left: newLeft, top: newTop };
    },

    setImagePosition: function(left, top) {
        // If the element is null, don't continue
        if (this.options.image == null)
            return;

        // Set the image's position by style
        this.options.image.style.left = left + "px";
        this.options.image.style.top = top + "px";
    },

    isZoomed: function() {
        return this.zoomLevel != 1.0;
    },

    zoomToNaturalDimensions: function() {       
        this.zoomLevel = this.getNaturalDimensionsZoomLevel();
        this.doZoom();
    },

    zoomToDefault: function () {
        this.zoomLevel = this.options.defaultZoomLevel;
        this.doZoom();
    },

    getNaturalDimensionsZoomLevel: function() {
        var naturalSize = Librarian.Utils.getNaturalImageSize(this.options.image);
        return (naturalSize.x / (this.originalSize.x * 1.0));
    }
});